import AddLineIconImport from './add_line.svg?react';
import ArrowLeftLineIconImport from './arrow_left_line.svg?react';
import ArrowRightLineIconImport from './arrow_right_line.svg?react';
import AttachmentLineIconImport from './attachment_line.svg?react';
import AudioFileIconImport from './audio.svg?react';
import CamcorderLineIconImport from './camcorder_line.svg?react';
import Camera2LineIconImport from './camera_2_line.svg?react';
import CheckCircleFillIconImport from './check_circle_fill.svg?react';
import CheckCircleLineIconImport from './check_circle_line.svg?react';
import CloseCircleFillIconImport from './close_circle_fill.svg?react';
import CloseCircleLineIconImport from './close_circle_line.svg?react';
import CloseLineIconImport from './close_line.svg?react';
import CodeFileIconImport from './code.svg?react';
import DefaultFileIconImport from './default_file.svg?react';
import Delete2LineIconImport from './delete_2_line.svg?react';
import DocumentFileIconImport from './doc.svg?react';
import DownLineIconImport from './down_line.svg?react';
import Download2LineIconImport from './download_2_line.svg?react';
import ExitLineIconImport from './exit_line.svg?react';
import Eye2LineIconImport from './eye_2_line.svg?react';
import FileLineIconImport from './file_line.svg?react';
import { withAntIconWrapper } from './icon-wrapper';
import ImgFileIconImport from './img.svg?react';
import Inbox2LineIconImport from './inbox_2_line.svg?react';
import InboxLineIconImport from './inbox_line.svg?react';
import InformationFillIconImport from './information_fill.svg?react';
import InformationLineIconImport from './information_line.svg?react';
import LeftLineIconImport from './left_line.svg?react';
import Link2LineIconImport from './link_2_line.svg?react';
import LoadingLineIconImport from './loading_line.svg?react';
import More2LineIconImport from './more_2_line.svg?react';
import NotificationOffLineIconImport from './notification_off_line.svg?react';
import PdfFileIconImport from './pdf.svg?react';
import PencilLineIconImport from './pencil_line.svg?react';
import PhoneFillIconImport from './phone_fill.svg?react';
import PicLineIconImport from './pic_line.svg?react';
import Pin2LineIconImport from './pin_2_line.svg?react';
import PinLineIconImport from './pin_line.svg?react';
import PptFileIconImport from './ppt.svg?react';
import QuestionFillIconImport from './question_fill.svg?react';
import Refresh1LineIconImport from './refresh_1_line.svg?react';
import RoundFillIconImport from './round_fill.svg?react';
import RoundLineIconImport from './round_line.svg?react';
import Search2LineIconImport from './search_2_line.svg?react';
import SendLineIconImport from './send_line.svg?react';
import SheetFileIconImport from './sheet.svg?react';
import TimeLineIconImport from './time_line.svg?react';
import User1LineIconImport from './user_1_line.svg?react';
import UserAddLineIconImport from './user_add_line.svg?react';
import UserRemoveLineIconImport from './user_remove_line.svg?react';
import VideoFileIconImport from './video.svg?react';
import WarningFillIconImport from './warning_fill.svg?react';
import WarningLineIconImport from './warning_line.svg?react';
import ZipFileIconImport from './zip.svg?react';

export const icons = {
  'add-line': withAntIconWrapper(AddLineIconImport),
  'arrow-left-line': withAntIconWrapper(ArrowLeftLineIconImport),
  'arrow-right-line': withAntIconWrapper(ArrowRightLineIconImport),
  'attachment-line': withAntIconWrapper(AttachmentLineIconImport),
  'audio-file': withAntIconWrapper(AudioFileIconImport),
  'camcorder-line': withAntIconWrapper(CamcorderLineIconImport),
  'camera-2-line': withAntIconWrapper(Camera2LineIconImport),
  'check-circle-fill': withAntIconWrapper(CheckCircleFillIconImport),
  'check-circle-line': withAntIconWrapper(CheckCircleLineIconImport),
  'close-circle-fill': withAntIconWrapper(CloseCircleFillIconImport),
  'close-circle-line': withAntIconWrapper(CloseCircleLineIconImport),
  'close-line': withAntIconWrapper(CloseLineIconImport),
  'code-file': withAntIconWrapper(CodeFileIconImport),
  'default-file': withAntIconWrapper(DefaultFileIconImport),
  'delete-2-line': withAntIconWrapper(Delete2LineIconImport),
  'document-file': withAntIconWrapper(DocumentFileIconImport),
  'down-line': withAntIconWrapper(DownLineIconImport),
  'download-2-line': withAntIconWrapper(Download2LineIconImport),
  'exit-line': withAntIconWrapper(ExitLineIconImport),
  'eye-2-line': withAntIconWrapper(Eye2LineIconImport),
  'file-line': withAntIconWrapper(FileLineIconImport),
  'img-file': withAntIconWrapper(ImgFileIconImport),
  'inbox-2-line': withAntIconWrapper(Inbox2LineIconImport),
  'inbox-line': withAntIconWrapper(InboxLineIconImport),
  'information-fill': withAntIconWrapper(InformationFillIconImport),
  'information-line': withAntIconWrapper(InformationLineIconImport),
  'left-line': withAntIconWrapper(LeftLineIconImport),
  'link-2-line': withAntIconWrapper(Link2LineIconImport),
  'loading-line': withAntIconWrapper(LoadingLineIconImport),
  'more-2-line': withAntIconWrapper(More2LineIconImport),
  'notification-off-line': withAntIconWrapper(NotificationOffLineIconImport),
  'pdf-file': withAntIconWrapper(PdfFileIconImport),
  'pencil-line': withAntIconWrapper(PencilLineIconImport),
  'phone-fill': withAntIconWrapper(PhoneFillIconImport),
  'pic-line': withAntIconWrapper(PicLineIconImport),
  'pin-2-line': withAntIconWrapper(Pin2LineIconImport),
  'pin-line': withAntIconWrapper(PinLineIconImport),
  'ppt-file': withAntIconWrapper(PptFileIconImport),
  'question-fill': withAntIconWrapper(QuestionFillIconImport),
  'refresh-1-line': withAntIconWrapper(Refresh1LineIconImport),
  'round-fill': withAntIconWrapper(RoundFillIconImport),
  'round-line': withAntIconWrapper(RoundLineIconImport),
  'search-2-line': withAntIconWrapper(Search2LineIconImport),
  'send-line': withAntIconWrapper(SendLineIconImport),
  'sheet-file': withAntIconWrapper(SheetFileIconImport),
  'time-line': withAntIconWrapper(TimeLineIconImport),
  'user-1-line': withAntIconWrapper(User1LineIconImport),
  'user-add-line': withAntIconWrapper(UserAddLineIconImport),
  'user-remove-line': withAntIconWrapper(UserRemoveLineIconImport),
  'video-file': withAntIconWrapper(VideoFileIconImport),
  'warning-fill': withAntIconWrapper(WarningFillIconImport),
  'warning-line': withAntIconWrapper(WarningLineIconImport),
  'zip-file': withAntIconWrapper(ZipFileIconImport),
} as const;

export type IconName = keyof typeof icons;
